module.exports = __webpack_public_path__ + "images/premium3-d264874a907e302648cd0b84662a2e25.jpg";